import { apiClient } from './api';
import type {
  AddGapCommentApiRequest,
  GapCommentsApiResponse,
  GetDealIntelligenceApiResponse,
  SubmitGapFeedbackApiRequest,
  SubmitGapFeedbackApiResponse,
} from '@momentum/types';

export const gapService = {
  async getDealIntelligence(): Promise<GetDealIntelligenceApiResponse> {
    return (await apiClient.get('/gaps/deal-intelligence')).data;
  },

  async submitGapFeedback(
    gapId: string,
    request: SubmitGapFeedbackApiRequest
  ): Promise<SubmitGapFeedbackApiResponse> {
    return (await apiClient.put(`/gaps/${gapId}/feedback`, request)).data;
  },

  async addGapComment(
    gapId: string,
    request: AddGapCommentApiRequest
  ): Promise<GapCommentsApiResponse> {
    return (await apiClient.post(`/gaps/${gapId}/comments`, request)).data;
  },

  async deleteGapComment(
    gapId: string,
    commentId: string
  ): Promise<GapCommentsApiResponse> {
    return (await apiClient.delete(`/gaps/${gapId}/comments/${commentId}`))
      .data;
  },
};
